exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-d5ea9138]{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/usr/src/nuxt-app/assets","/static":"/usr/src/nuxt-app/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d5ea9138","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layouts/error.vue
// module id = pbUp
// module chunks = 9